import { createContext, useState, useEffect, type PropsWithChildren } from 'react'

const PrefersReducedMotionContext = createContext<boolean>(false)

export function PrefersReducedMotionContextProvider({ children }: PropsWithChildren) {
  // Starts as false even on client, to ensure initial client render matches SSR
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (!mediaQuery) return
    setPrefersReducedMotion(mediaQuery.matches)
    const handler = (event: MediaQueryListEvent) => setPrefersReducedMotion(event.matches)
    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }, [])

  return <PrefersReducedMotionContext value={prefersReducedMotion}>
    {children}
  </PrefersReducedMotionContext>
}

export default PrefersReducedMotionContext
